module.exports = __webpack_public_path__ + "static/media/kin.3a8d200a.jpg";